import { JSX } from "react";
import { useTranslation } from "react-i18next";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";

import ButtonGroup from "lib/ui/button/ButtonGroup";

import { asTitle } from "utils/Utils";

export type ReportViewActionbarProps = {
	editEnabled: boolean;

	onEdit: () => void;
	onClose: () => void;
};

export default function ReportViewActionbar(
	props: Readonly<ReportViewActionbarProps>
): JSX.Element {
	const { t } = useTranslation();

	return (
		<ButtonGroup>
			<Tooltip title={asTitle(t("edit"))}>
				<span>
					<IconButton
						aria-label="edit-report"
						disabled={!props.editEnabled}
						onClick={props.onEdit}
						size="large">
						<EditIcon />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title={asTitle(t("close"))}>
				<span>
					<IconButton
						aria-label="close-report"
						onClick={props.onClose}
						size="large">
						<CloseIcon />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title={asTitle(t("print"))}>
				<span>
					<IconButton
						aria-label="print-report"
						size="large"
						onClick={window.print}>
						<PrintIcon />
					</IconButton>
				</span>
			</Tooltip>
		</ButtonGroup>
	);
}
